import { sentryLogger } from "./SentryLogger";
import { sentryLoggerHOC } from "./SentryLoggerHOC";
/**
 * One-call bootstrap for a micro-app root: builds the logger and its HOC together in one closure, so
 * the HOC can never be rebuilt per render.
 */
const sentryScreenRoot = ({ sentry, fallback, role }) => {
    const logger = sentryLogger(sentry, { role });
    return sentryLoggerHOC({ logger, fallback });
};
export { sentryScreenRoot };
